import { memo } from "react";

function Icon_LicencedVolume() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M5 3L5 1L0 1L0 3L5 3Z" fill="currentColor" />
      <path d="M13 3V1H7V3H13Z" fill="currentColor" />
      <path d="M20 3V1H15V3H20Z" fill="currentColor" />
      <path
        d="M14.5303 9.46973L13.4697 10.5303L10.75 7.81055V20H9.25V7.81055L6.53027 10.5303L5.46973 9.46973L10 4.93945L14.5303 9.46973Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default memo(Icon_LicencedVolume);
